import HttpClient from "../Tools/HttpClient";
import baseApiPath from "../Tools/baseApiPath";

export class BaseService {
  get http() {
    return new HttpClient();
  }
}
